import { $http } from "@/assets/js/appFunc";

export const getAppMList = (context) => {
    if (context.state.appMList.length === 0) {
        const req = {
            type: "GET",
            url: "/app/getProcessDefForApp?appId=747e9767-bfe5-4c49-b042-488ab336489e&filtered=false",
            data: null
        };
        $http(req).then(
            data => context.commit("setAppMList", data),
            error => console.log(error)
        );
    }
};

export const deleteAppM = (context, app) => {
    delete app.__index;
    const req = {
        type: "DELETE",
        url: `/processType/${app.appId}`,
        data: null
    };
    $http(req).then(
        data => context.commit("deleteAppM", app),
        error => console.log(error)
    );
};

export const deleteAppMMultiple = (context, list) => {
    const payload = list.map(app => app.appId);
    const req = {
        type: "DELETE",
        url: "/processType/list",
        data: payload
    };
    $http(req).then(
        data => {
            for (const app of list) {
                delete app.__index;
                context.commit("deleteAppM", app);
            }
        },
        error => console.log(error)
    );
};
